import {Component, Input, ElementRef, AfterViewInit, OnDestroy} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Router} from "@angular/router";
import {ApiEndpoints} from "../../services/api-endpoints";

@Component({ standalone: false, 
  selector: 'app-delete-modal',
  inputs: ['text'],
  templateUrl: 'delete-modal.component.html',
})
export class DeleteModalComponent implements AfterViewInit, OnDestroy {
  @Input() server;
  @Input() netBid;
  @Input() deleteType;
  @Input() nsId;
  @Input() jsId;
  @Input() rfParamSetId;
  @Input() roamingCommunityId;

  public visible: boolean = false;
  public visibleAnimate: boolean = false;
  public setTimeout: number = 200;
  public text: string;
  public deleteResponse: string;

  constructor(public http: HttpClient,
              public router: Router,
              private el: ElementRef){}

  ngAfterViewInit() {
    document.body.appendChild(this.el.nativeElement);
  }

  ngOnDestroy() {
    if (this.el.nativeElement.parentElement === document.body) {
      document.body.removeChild(this.el.nativeElement);
    }
  }

  public show(): void {
    this.visible = true;
    setTimeout(() => this.visibleAnimate = true, this.setTimeout);
  }

  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => this.visible = false, this.setTimeout);
  }

  public onContainerClicked(event: MouseEvent): void {
    event.stopPropagation();
    if ((<HTMLElement>event.target).classList.contains('deleteModal')) {
      this.hide();
    }
  }
  deleteServer(){
    const headers = new HttpHeaders({'Content-Type':  'application/json'});
    let options =  {headers: headers};
    switch(this.deleteType) {
      case 'joinServer':
        let joinUrl = ApiEndpoints.DELETE_JOIN_SERVER;
        var body: any = { "virtId": this.server };
        this.http.post<any>(joinUrl, body, options).subscribe(
            data => {
              this.deleteResponse = data;
              this.visible = false;
              window.location.reload();
            }
          );
        break;

      case 'joinServerDetail':
        let joinServerDetail = ApiEndpoints.DELETE_JOIN_SERVER;
        var body: any = { "virtId": this.server };
        this.http.post<any>(joinServerDetail, body, options).subscribe(
            data => {
              this.deleteResponse = data;
              this.visible = false;
              this.router.navigate(['./all-join']);
            }
          );
        break;

      case 'networkServer':
        let nerworkUrl = ApiEndpoints.DELETE_NETWORK_SERVER;
        var body: any = { "virtId": this.server };
        this.http.post<any>(nerworkUrl, body, options).subscribe(
            data => {
              this.deleteResponse = data;
              this.visible = false;
              window.location.reload();
            }
          );
        break;

      case 'networkServerDetail':
        let netServerDetail = ApiEndpoints.DELETE_NETWORK_SERVER;
        var body: any = { "virtId": this.server };
        this.http.post<any>(netServerDetail, body, options).subscribe(
            data => {
              this.deleteResponse = data;
              this.visible = false;
              this.router.navigate(['./all-network']);
            }
          );
        break;

      case 'networkServerGroup':
        let netServerGroupDetail = ApiEndpoints.DELETE_NETWORK_SERVER_GROUP;
        var body: any = { "virtId": this.server };
        this.http.post<any>(netServerGroupDetail, body, options).subscribe(
             data => {
               this.deleteResponse = data;
               this.visible = false;
               window.location.reload();
             }
          );
        break;

      case 'networkServerGroupDetail':
        let netGroupDetail = ApiEndpoints.DELETE_NETWORK_SERVER_GROUP;
        var body: any = { "virtId": this.server };
        this.http.post<any>(netGroupDetail, body, options).subscribe(
            data => {
              this.deleteResponse = data;
              this.visible = false;
              this.router.navigate(['./all-network-groups']);
            }
          );
        break;

      case 'roamingPartners':
        let roamingUrl = ApiEndpoints.DELETE_ROAMING_AGREEMENT;
        var body: any = { "nsAid":  this.server, "nsBid": this.netBid};
        this.http.post<any>(roamingUrl, body, options).subscribe(
            data => {
              this.deleteResponse = data;
              this.visible = false;
              window.location.reload();
            }
          );
        break;

      case 'activationAgreement':
        let activationUrl = ApiEndpoints.DELETE_ACTIVATION_AGREEMENT;
        var body: any = { "nsId": this.nsId, "jsId": this.jsId };
        this.http.post<any>(activationUrl, body, options).subscribe(
            data => {
              this.deleteResponse = data;
              this.visible = false;
              window.location.reload();
            }
          );
        break;

      case 'rfParamSetElement':
        let paramSetElementUrl = ApiEndpoints.REMOVE_RF_PARAM_SET_ELEMENT;
        var body: any = { "virtId": this.nsId, "psId": this.rfParamSetId };
        this.http.post<any>(paramSetElementUrl, body, options).subscribe(
              data => {
                this.deleteResponse = data;
                this.visible = false;
                window.location.reload();
              }
            );
        break;

      case 'roamingCommunity':
        let roamingCommunityUrl = ApiEndpoints.DELETE_ROAMING_COMMUNITY;
        var body: any = { "virtId": this.server };
        this.http.post<any>(roamingCommunityUrl, body, options).subscribe(
            data => {
              this.deleteResponse = data;
              this.visible = false;
              this.router.navigate(['./all-roaming-community']);
            }
          );
        break;

      case 'roamingCommunityMember':
        let roamingCommunityMemberUrl = ApiEndpoints.DELETE_ROAMING_COMMUNITY_MEMBER;
        var body: any = { "nsId": this.nsId, "rcId": this.roamingCommunityId };
        this.http.post<any>(roamingCommunityMemberUrl, body, options).subscribe(
            data => {
              this.deleteResponse = data;
              this.visible = false;
              window.location.reload();
            }
          );
        break;
    }
  }
}
